import React, { useState } from 'react';
import {
	makeStyles,
	Box,
	FormControlLabel,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import { Field, Form, Formik } from 'formik';
import TitleText from '../components/reusableComponents/TitleText';
import BodyText from '../components/reusableComponents/BodyText';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import upipayment from '../assets/images/upipayment.png';
import tripmoney from '../assets/images/tripmoney.png';
import sbi from '../assets/images/sbi.png';
import pay_later_interest from '../assets/images/pay_later_interest.png';
import pay_later_credit_period from '../assets/images/pay_later_credit_period.png';
import pay_later_late_fees from '../assets/images/pay_later_late_fees.png';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {},
	},

	inputPropsStyle: {
		padding: 14,
	},

	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 18,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 16,
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
	},
}));
const title = [
	'January(01)',
	'February(02)',
	'March(03)',
	'April(04)',
	'May(05)',
	'June(06)',
	'July(07)',
	'August(08)',
	'September(09)',
	'October(10)',
	'November(11)',
	'December(12)',
];
const years = ['2022', '2023', '2024', '2025', '2026', '2027', '2028'];
const CheckoutForm = ({ value }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const [data, setData] = useState(1);
	const handleFormSubmit = (data, actions) => {};

	return (
		<Formik
			initialValues={{}}
			validate={(values) => {
				const errors = {};

				return errors;
			}}
			onSubmit={handleFormSubmit}>
			{({ submitForm, isSubmitting, values, errors }) => (
				<>
					{' '}
					<Form>
						{value == 2 && (
							<Grid container className={classes.root}>
								<Grid item xs={12}>
									<TitleText four textStyle={{ marginTop: 10 }}>
										Card Number
									</TitleText>
									<Field
										component={TextField}
										name='first_name'
										type='text'
										variant='outlined'
										label='Enter Your Card Number Here'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										style={{ marginTop: 10 }}
										inputProps={
											{
												// style: { padding: 14 },
											}
										}
									/>
								</Grid>
								<Grid item xs={12}>
									<TitleText four textStyle={{ marginTop: 10 }}>
										Name on Card
									</TitleText>
									<Field
										component={TextField}
										name='first_name'
										style={{ marginTop: 10 }}
										type='text'
										variant='outlined'
										label='Enter Your Name on Card'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={
											{
												// style: { padding: 14 },
											}
										}
									/>
								</Grid>
								<Grid item xs={12}>
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<TitleText four textStyle={{ marginTop: 10 }}>
												Expiry Month & Year
											</TitleText>
											<Grid container>
												<Grid item xs={6}>
													<Field
														component={TextField}
														select
														name='title'
														type='text'
														style={{ marginTop: 10 }}
														variant='outlined'
														label='Months'
														error={errors.title}
														// style={{ marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{title.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														select
														name='title'
														type='text'
														style={{ marginTop: 10 }}
														variant='outlined'
														label='Years'
														error={errors.title}
														// style={{ marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															className: classes.inputPropsStyle,
														}}>
														{years.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={6}>
											<TitleText four textStyle={{ marginTop: 10 }}>
												Card CVV
											</TitleText>
											<Field
												component={TextField}
												name='first_name'
												type='text'
												variant='outlined'
												style={{ marginTop: 10 }}
												label='Enter Your Name on Card'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={
													{
														// style: { padding: 14 },
													}
												}
											/>
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={12}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{ padding: 20 }}
										alignItems='center'>
										<TitleText textStyle={{ fontSize: 20 }}>
											Rs 23,152
										</TitleText>
										<Box
											style={{
												backgroundImage:
													'linear-gradient(96deg,#53b2fe,#065af3)',
												color: '#fff',
												padding: '0 20px',
												height: '40px',
												borderRadius: '36px',
												boxShadow: '0 1px 7px 0 rgb(0 0 0 / 20%)',
												cursor: 'pointer',
											}}>
											<TitleText textStyle={{ fontSize: 16, marginTop: 5 }}>
												Pay Now
											</TitleText>
										</Box>
									</Box>
								</Grid>
							</Grid>
						)}
						{value == 1 && (
							<Grid container className={classes.root}>
								<Grid item xs={12}>
									<TitleText four textStyle={{ marginTop: 10 }}>
										Enter UPI ID
									</TitleText>
									<Field
										component={TextField}
										name='first_name'
										type='text'
										variant='outlined'
										label='mobilenumber@upi'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										style={{ marginTop: 10 }}
										inputProps={
											{
												// style: { padding: 14 },
											}
										}
									/>
								</Grid>
								<Grid item xs={12}>
									<Grid container>
										<Grid item xs={4}></Grid>
										<Grid item xs={12} sm={4} md={4}>
											<Box
												mt={'10px'}
												style={{
													backgroundImage:
														'linear-gradient(96deg,#53b2fe,#065af3)',
													color: '#fff',
													padding: '0 20px',
													height: '40px',
													borderRadius: '36px',
													boxShadow: '0 1px 7px 0 rgb(0 0 0 / 20%)',
													cursor: 'pointer',
													paddingTop: 6,
													textAlign: 'center',
													overflow: 'hidden',
													whiteSpace: 'nowrap',
													textOverflow: 'ellipsis',
												}}>
												<TitleText textStyle={{ fontSize: 16 }}>
													VERIFY & PAY
												</TitleText>
											</Box>
										</Grid>
										<Grid item xs={4}></Grid>
									</Grid>
								</Grid>
								<Grid item xs={12} style={{ marginTop: 20 }}>
									<Grid container>
										<Grid item xs={2}></Grid>
										<Grid item xs={8}>
											<img src={upipayment} style={{ width: '100%' }}></img>
										</Grid>
										<Grid item xs={2}></Grid>
									</Grid>
								</Grid>
							</Grid>
						)}
						{value == 3 && (
							<>
								<TitleText textStyle={{ fontSize: 18 }}>
									Benefits of Pay Later
								</TitleText>
								<Grid
									container
									style={{ marginTop: 20 }}
									className={classes.root}>
									<Grid item xs={6}>
										<Box display='flex' alignItems='center'>
											<img
												src={pay_later_interest}
												style={{ width: 50, height: 50 }}></img>
											<Box ml={'5px'}>
												<TitleText textStyle={{ color: '#249b95' }}>
													0% Interest
												</TitleText>
												<BodyText>for non-EMI plans</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={6}>
										<Box display='flex' alignItems='center'>
											<img
												src={pay_later_credit_period}
												style={{ width: 50, height: 50 }}></img>
											<Box ml={'5px'}>
												<TitleText textStyle={{ color: '#249b95' }}>
													Multiple Credit Periods
												</TitleText>
												<BodyText>from 15 days to 18 month tenures</BodyText>
											</Box>
										</Box>
									</Grid>
								</Grid>
								<Grid
									container
									style={{ marginTop: 20 }}
									className={classes.root}>
									<Grid item xs={6}>
										<Box display='flex' alignItems='center'>
											<img
												src={pay_later_late_fees}
												style={{ width: 50, height: 50 }}></img>
											<Box ml={'5px'}>
												<TitleText textStyle={{ color: '#249b95' }}>
													No KYC:No Documents
												</TitleText>
												<BodyText>Mobile no. based eligibility</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={6}>
										<Box display='flex' alignItems='center'>
											<img
												src={pay_later_credit_period}
												style={{ width: 50, height: 50 }}></img>
											<Box ml={'5px'}>
												<TitleText textStyle={{ color: '#249b95' }}>
													Checkout via OTP
												</TitleText>
												<BodyText>received on your mobile no.</BodyText>
											</Box>
										</Box>
									</Grid>
								</Grid>
								<Box
									mt={'20px'}
									display='flex'
									justifyContent='space-between'
									style={{ border: 'solid 1px #e7e7e7', padding: 20 }}>
									<Box>
										<TitleText>Check eligibility of mobile no.</TitleText>
										<TitleText>91 8092184478</TitleText>
									</Box>
									<Box
										style={{
											backgroundImage: 'linear-gradient(96deg,#53b2fe,#065af3)',
											color: '#fff',
											padding: '0 20px',
											height: '40px',
											borderRadius: '36px',
											boxShadow: '0 1px 7px 0 rgb(0 0 0 / 20%)',
											cursor: 'pointer',
										}}>
										<TitleText textStyle={{ fontSize: 16, marginTop: 5 }}>
											PROCEED
										</TitleText>
									</Box>
								</Box>
							</>
						)}
						{value == 4 && (
							<>
								<TitleText textStyle={{ fontSize: 15 }}>
									Select Your Bank
								</TitleText>
								<Grid container>
									{[0, 1, 2, 3, 4].map((i, index) => {
										return (
											<>
												<Grid item xs={12}>
													<Box
														alignItems='center'
														display='flex'
														style={{
															marginTop: index == 0 ? 25 : '',
															boxShadow: '0 1px 4px 0 rgb(0 0 0 / 20%)',
															boder: 'solid 1px #f0f0f0',
															borderRadius: 4,
															padding: '10px 15px',
														}}>
														<FormControlLabel
															value='female'
															control={<Radio />}
															// label='Female'
														/>
														<img
															src={sbi}
															style={{ width: 30, height: 20 }}></img>
														<TitleText
															textStyle={{
																fontSize: 16,
																fontWeight: 500,
															}}>
															State Bank of India
														</TitleText>
													</Box>
												</Grid>
											</>
										);
									})}
								</Grid>
								<Grid item xs={12}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{ padding: 20 }}
										alignItems='center'>
										<TitleText textStyle={{ fontSize: 20 }}>
											Rs 23,152
										</TitleText>
										<Box
											style={{
												backgroundImage:
													'linear-gradient(96deg,#53b2fe,#065af3)',
												color: '#fff',
												padding: '0 20px',
												height: '40px',
												borderRadius: '36px',
												boxShadow: '0 1px 7px 0 rgb(0 0 0 / 20%)',
												cursor: 'pointer',
											}}>
											<TitleText textStyle={{ fontSize: 16, marginTop: 5 }}>
												Pay Now
											</TitleText>
										</Box>
									</Box>
								</Grid>
							</>
						)}

						{value == 5 && (
							<>
								<TitleText textStyle={{ fontSize: 15 }}>
									Select Wallet to Pay
								</TitleText>
								<Grid
									container
									style={{ marginTop: 10 }}
									spacing={1}
									className={classes.root}>
									{[0, 1, 2, 3, 4, 5, 6].map((i) => {
										return (
											<Grid item xs={3}>
												<Box
													style={{
														border: 'solid 1px #dfdfdf',
														padding: '22px',
														textAlign: 'center',
													}}>
													<img
														src={tripmoney}
														style={{
															width: 24,
															height: 24,
														}}></img>
													<TitleText
														textStyle={{
															fontSize: 14,
															marginTop: 10,
														}}>
														Trip Money
													</TitleText>
												</Box>
											</Grid>
										);
									})}
								</Grid>
							</>
						)}
						{value == 6 && (
							<>
								<Box display='flex' justifyContent='space-between' mt={'20px'}>
									<TitleText textStyle={{ fontSize: 15 }}>
										Select Your Bank
									</TitleText>
									<Box
										onClick={() => setData(1)}
										style={{
											background: data == 1 ? '#e6f2ff' : 'white',
											border: 'solid 1px #e1e1e1',
											padding: '5px 10px',
											borderRadius: 13,
											cursor: 'pointer',
										}}
										display='flex'
										justifyContent='space-between'>
										<BodyText>Credit Card</BodyText>
										{data == 1 ? (
											<BodyText textStyle={{ marginLeft: 5 }}>X</BodyText>
										) : (
											''
										)}
									</Box>
									<Box
										onClick={() => setData(2)}
										style={{
											background: data == 2 ? '#e6f2ff' : 'white',
											border: 'solid 1px #e1e1e1',
											padding: '5px 10px',
											borderRadius: 13,
											cursor: 'pointer',
										}}
										display='flex'
										justifyContent='space-between'>
										<BodyText>Debit Card</BodyText>
										{data == 2 ? (
											<BodyText textStyle={{ marginLeft: 5 }}>X</BodyText>
										) : (
											''
										)}
									</Box>
									<Box
										onClick={() => setData(3)}
										style={{
											background: data == 3 ? '#e6f2ff' : 'white',
											border: 'solid 1px #e1e1e1',
											padding: '5px 10px',
											borderRadius: 13,
											cursor: 'pointer',
										}}
										display='flex'
										justifyContent='space-between'>
										<BodyText>No Cost EMI</BodyText>
										{data == 3 ? (
											<BodyText textStyle={{ marginLeft: 5 }}>X</BodyText>
										) : (
											''
										)}
									</Box>
								</Box>
								<Grid container>
									{[0, 1, 2, 3, 4].map((i, index) => {
										return (
											<>
												<Grid item xs={12}>
													<Box
														justifyContent='space-between'
														alignItems='center'
														display='flex'
														style={{
															marginTop: index == 0 ? 25 : '',
															boxShadow: '0 1px 4px 0 rgb(0 0 0 / 20%)',
															boder: 'solid 1px #f0f0f0',
															borderRadius: 4,
															padding: '10px 15px',
														}}>
														<Box display='flex' alignItems='center'>
															<FormControlLabel
																value='female'
																control={<Radio />}
																// label='Female'
															/>
															<img
																src={sbi}
																style={{ width: 30, height: 20 }}></img>
															<TitleText
																textStyle={{
																	fontSize: 16,
																	fontWeight: 500,
																}}>
																State Bank of India
															</TitleText>
														</Box>
														<TitleText>15% interest</TitleText>
													</Box>
												</Grid>
											</>
										);
									})}
								</Grid>
								<Grid item xs={12}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{ padding: 20 }}
										alignItems='center'>
										<TitleText textStyle={{ fontSize: 20 }}>
											Rs 23,152
										</TitleText>
										<Box
											style={{
												backgroundImage:
													'linear-gradient(96deg,#53b2fe,#065af3)',
												color: '#fff',
												padding: '0 20px',
												height: '40px',
												borderRadius: '36px',
												boxShadow: '0 1px 7px 0 rgb(0 0 0 / 20%)',
												cursor: 'pointer',
											}}>
											<TitleText textStyle={{ fontSize: 16, marginTop: 5 }}>
												Pay Now
											</TitleText>
										</Box>
									</Box>
								</Grid>
							</>
						)}
					</Form>
				</>
			)}
		</Formik>
	);
};

export default CheckoutForm;
